var map = {
	"./Screen Shot 2020-10-19 at 5.18.23 PM.png": 16,
	"./Screen Shot 2020-10-19 at 7.26.10 PM.png": 17,
	"./purty_wood.png": 70,
	"./purty_wood_@2X.png": 71,
	"./sjsu_logo.png": 72,
	"./ucsc_logo.png": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;